import { ButtonLink } from './buttonlink';

/**
 * @deprecated use BX.UI.Button
 */
export class PopupWindowButtonLink extends ButtonLink
{
	// No additional functionality, just for compatibility
}
